import { createContext, useContext } from "react";
import type { Moi } from "@/components/atomic-crm/providers/atelier";
export const MoiContext = createContext<Moi | null>(null);
export const useMoi = () => useContext(MoiContext);
